import {Component, OnInit} from '@angular/core';
import {UserService} from "../../services/user/user.service";
import {CompanyService} from "../../services/company/company.service";
import {Company} from "../../models/company";
import Swal from "sweetalert2";
import {Router} from "@angular/router";

@Component({
    selector: 'app-forgot-password',
    templateUrl: './forgot-password.component.html',
    styleUrls: ['./forgot-password.component.scss']
})
export class ForgotPasswordComponent implements OnInit {

    email: string | undefined;
    company: Company | null = null;
    loadingCompany = true;

    constructor(
        public userService: UserService,
        public router: Router,
        private companyService: CompanyService,
    ) {
    }

    async ngOnInit() {
        try {
            this.company = await this.companyService.getCompanyFromDomain(window.location.hostname) ?? null;
        } catch (e) {
            console.error('Forgot password company lookup error:', e);
        } finally {
            this.loadingCompany = false;
        }
    }

    get isCompanyBranded(): boolean {
        return !!this.company?.id;
    }

    get brandingLogo(): string {
        return this.company?.logoUrl || 'assets/logo.svg';
    }

    get welcomeTitle(): string {
        return this.isCompanyBranded ? 'Benvenuto' : 'Benvenuto su Well Done';
    }

    get welcomeSubtitle(): string {
        if (this.isCompanyBranded && this.company?.name) {
            return `Recupera l'accesso all'area riservata di ${this.company.name}`;
        }
        return 'Recupera l\'accesso alla piattaforma di gestione per società sportive';
    }

    async recoverPassword() {
        if (!this.email) return;

        let response = await this.userService.recoverPassword(this.email!);

        if (response.success) {
            Swal.fire({
                icon: 'success',
                title: 'Ti abbiamo inviato una email per poter proseguire con la procedura!'
            });
            this.router.navigate(['/reset-password/' + this.email])
        } else {
            if (response.code === 'USER_NOT_FOUND') {
                Swal.fire({
                    icon: 'error',
                    title: 'Utente non trovato'
                });
            } else {
                Swal.fire({
                    icon: 'error',
                    title: 'Errore durante la procedura, riprova tra poco'
                });
            }
        }
    }
}
